import { VirtualBackground } from '../types';

const initialVirtualBgState: VirtualBackground = {
  url: '',
  type: 'none',
  index: -1,
  privacy: 'PUBLIC',
  id: '',
};

export const getVirtualBackgroundFromStorage = (): VirtualBackground => {
  const vbSelection = localStorage.getItem('covideoVirtualBackground') || '';
  try {
    const savedVirtualBackground: VirtualBackground = JSON.parse(vbSelection);
    if (savedVirtualBackground && typeof savedVirtualBackground === 'object') {
      return savedVirtualBackground;
    }
    return initialVirtualBgState;
  } catch (ex) {
    return initialVirtualBgState;
  }
};
export const saveVirtualBackgroundToStorage = (
  currentVirtualBackground: VirtualBackground
) => {
  localStorage.setItem(
    'covideoVirtualBackground',
    JSON.stringify(currentVirtualBackground)
  );
};
